import {LangUtil} from '../lang-util'

export const companiesEn = {
  myCompany: 'My company',
  add: 'Add company',
  namePlaceholder: 'Company name',
  warn1: 'Companies are not related with each other.',
  warn2:
    'You can’t move boards, columns and tasks from one company to another.',
  departmentsTitle: 'Departments',
  addDepartment: 'Add department',
  departmentPlaceholder: 'Enter department’s name',
  departmentParentPlaceholder: 'Choose parent department',
  departmentParentWarn: 'Only admins can create top-level departments',
  addSubDepartmentHint: 'Add as subdepartment',
  departmentDisallowParentInsideChild:
    'You can’t move department inside its child department',
  departmentToTopLevel: 'Move to top level',
  department: 'Department',
  depName: 'Name',
  depManagers: 'Head of department',
  depMembers: 'Participants',
  depDelete: 'Delete department',
  depDeleteConfirm: 'Delete this department?',
  cantDeleteWithChildren:
    'Can’t delete department with subdepartments, delete or move subdepartments first',
  editDepUsers: 'edit users',
  position: 'Position',
  positionPl: 'Enter position',
  positionNotSet: 'not set',
  positionEditWarn: 'Only admins and can edit other’s positions',

  depPermissionsTitle: 'Type of department',
  depPermissionsOpen: 'Open',
  depPermissionsManaged: 'Managed',
  depPermissionsOpenDescr:
    'Members of department can see each others tasks without board. Also managers of department and managers of higher level department can see tasks without board of department members',
  depPermissionsManagedDescr:
    'Managers this of department and higher level departments can see tasks without board that are assigned to members of this department',
  depExampleMain: 'Main department',
  depExampleSub: 'Sub department',
  settings: 'Company settings',
  extensions: 'Extensions',
  inviteByMail: 'Invite employees by mail',
  whoCanAddProjects: 'Who can add new projects',
  whoCanAddProjectsOpts: {
    all: 'All users',
    managers: 'Department managers',
    admins: 'Only administrators'
  },
  whoCanEditPosition: 'Who can edit user position',
  whoCanEditPositionOpts: {
    self: 'Users can change self',
    managers: 'Department managers',
    admins: 'Only administrators'
  },
  whoCanSeeEmails: 'Who can see others e-mails',
  whoCanSeeEmailsOpts: {
    all: 'All users',
    managers: 'Department managers',
    admins: 'Only administrators'
  },
  whoCanEditOwnEmail: 'Who can edit own email',
  whoCanEditOwnEmailOpts: {
    all: 'All users',
    managers: 'Department managers',
    admins: 'Only administrators'
  },
  whoCanSeePage: (pageName: string) => `Who can see page “${pageName}”`,
  whoCanSeePageOpts: {
    all: 'All users',
    managers: 'Department managers',
    admins: 'Only administrators'
  },
  whoCanCreateGroupChat: 'Who can create group chats',
  whoCanCreateGroupChatOpts: {
    all: 'All users',
    managers: 'Department managers',
    admins: 'Only administrators'
  },
  setAutoCoverForNewBoards:
    'Automatically set the last image in chat as a cover for tasks in new boards',
  setUseOldId: 'Revert task ID to ID-xxx format',
  explainCompanyEdit: (companyName: string) =>
    LangUtil.stripMargin(`
    Settings for company “${companyName}”.
    Only administrators of this company can modify these settings.
  `),
  companyEditWarn: 'Only administrators can edit company settings',
  downloadProjectAsJson: 'Download this project data?',
  uploadProjectFromJson: 'Import project from file?',
  jsonFileExpected: 'File should be in json format',
  failedToReadFile: 'Failed to read file',
  editExtensions: 'Edit added extensions',
  setUseNewGantt: 'Enable a new Gantt chart view'
}

export const companiesRu: typeof companiesEn = {
  myCompany: 'Моя компания',
  add: 'Создать компанию',
  namePlaceholder: 'Название компании',
  warn1: 'Компании никак не связаны между собой.',
  warn2:
    'Невозможно переносить между компаниями доски, колонки и задачи. ' +
    'В новую компанию нужно будет приглашать сотрудников.',
  departmentsTitle: 'Отделы компании',
  addDepartment: 'Добавить отдел',
  departmentPlaceholder: 'Введите название отдела',
  departmentParentPlaceholder: 'Выберите вышестоящий отдел',
  departmentParentWarn:
    'Создавать отделы, которые не подчиняются другим отделам могут только администраторы компании',
  addSubDepartmentHint: 'Добавить как подчинённый отдел',
  departmentDisallowParentInsideChild:
    'Нельзя переносить отдел в подчинённый ему отдел',
  departmentToTopLevel: 'Перенести на верхний уровень',
  department: 'Отдел',
  depName: 'Название',
  depManagers: 'Руководители',
  depMembers: 'Сотрудники',
  depDelete: 'Удалить отдел',
  depDeleteConfirm: 'Удалить отдел в компании?',
  cantDeleteWithChildren:
    'Нельзя удалить отдел с подчинёнными отделами, сначала удалите или перенесите подчинённые отделы',
  editDepUsers: 'редактировать состав',
  position: 'Должность',
  positionPl: 'Введите должность',
  positionNotSet: 'не установлена',
  positionEditWarn:
    'Вы можете менять только свою должность, т.к. вы не администратор',

  depPermissionsTitle: 'Тип отдела',
  depPermissionsOpen: 'Открытый',
  depPermissionsManaged: 'С иерархией',
  depPermissionsOpenDescr:
    'Участники отдела могут оценивать загруженность друг друга и общаться по задачам. Задачи без привязки к доскам, поставленные на сотрудников внутри отдела, видны сотрудникам отдела и руководителю, а также всем руководителям вышестоящих отделов',
  depPermissionsManagedDescr:
    'Сотрудники не видят задачи друг друга. Только руководители этого и вышестоящих отделов видят все задачи без досок, назначенные на сотрудников этого отдела',
  depExampleMain: 'Основной отдел',
  depExampleSub: 'Подчинённый отдел',
  settings: 'Настройки компании',
  extensions: 'Расширения',
  inviteByMail: 'Пригласить сотрудников по почте',
  whoCanAddProjects: 'Кто может создавать новые проекты',
  whoCanAddProjectsOpts: {
    all: 'Все пользователи',
    managers: 'Руководители отделов и администраторы',
    admins: 'Только администраторы'
  },
  whoCanEditPosition: 'Кто может редактировать должность пользователя',
  whoCanEditPositionOpts: {
    self: 'Сам пользователь и администраторы',
    managers: 'Руководители отделов и администраторы',
    admins: 'Только администраторы'
  },
  whoCanSeeEmails: 'Кто может видеть e-mail-ы в карточках сотрудников',
  whoCanSeeEmailsOpts: {
    all: 'Все пользователи',
    managers: 'Руководители отделов и администраторы',
    admins: 'Только администраторы'
  },
  whoCanEditOwnEmail: 'Кто может редактировать свой e-mail',
  whoCanEditOwnEmailOpts: {
    all: 'Все пользователи',
    managers: 'Руководители отделов и администраторы',
    admins: 'Только администраторы'
  },
  whoCanSeePage: (pageName: string) =>
    `Кто может видеть страницу “${pageName}”`,
  whoCanSeePageOpts: {
    all: 'Все пользователи',
    managers: 'Руководители отделов и администраторы',
    admins: 'Только администраторы'
  },
  whoCanCreateGroupChat: 'Кто может создавать групповые чаты',
  whoCanCreateGroupChatOpts: {
    all: 'Все пользователи',
    managers: 'Руководители отделов и администраторы',
    admins: 'Только администраторы'
  },
  setAutoCoverForNewBoards:
    'Автоматически делать последнюю картинку в чате обложкой задачи для новых досок',
  setUseOldId: 'Вернуть ID задачи к формату ID-xxx',
  explainCompanyEdit: (companyName: string) =>
    LangUtil.stripMargin(`
    Настройки компании “${companyName}”.
    Только администраторы компании могут изменять эти настройки.
  `),
  companyEditWarn: 'Только администраторы могут изменять настройки компании',
  downloadProjectAsJson: 'Скачать данные этого проекта?',
  uploadProjectFromJson: 'Импортировать проект из файла?',
  jsonFileExpected: 'Файл должен быть в формате json',
  failedToReadFile: 'Не удалось прочитать файл',
  editExtensions: 'Подключить расширения',
  setUseNewGantt: 'Включить новый вид диаграммы Ганта'
}
